import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7402Model } from "../kymw7402.model";

/** レスポンス構造 */
export type GetFixedOrderListResponse = {
  OrderCode: string;
  CatalogId: string;
  RegistCycle: string
}[]

/**
 * 企画確定受注コード一覧取得
 * 
 */
@Injectable()
export class GetFixedOrderListService extends PlessJsonResponderSub<GetFixedOrderListResponse> {

  private model: KYMW7402Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * 
   */
  private getBody() {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   * 
   * @param model 
   * @param successFunc 
   */
  execute(model: KYMW7402Model, successFunc: Function = null ) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getFixedOrderList', this.getBody());
  }

  /**
   * API通信成功時の処理
   * @param data 
   */
  success(data: GetFixedOrderListResponse): void {
    this.model.setFixedOrderList(data);
    if ( this.successFunc !== null ) {
      this.successFunc(data);
    }
  }
}